import { FormControl, FormGroup } from "@angular/forms";
import * as dayjs from 'dayjs';
import *as customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat)

export function dataRangeValidator() {
  return (group: FormGroup): { [key: string]: any } | null => {
    // // console.log(group.value)
    const dateInicio = group.value[0];
    const dateFinal = group.value[1];

    if (dateInicio && dateFinal && dateInicio >= dateFinal) {
      return { 'invalidRange': true };
    }

    return null;
  };

  // return function (control: FormControl) {

  //   // console.log(dataLimiteInicio, dataLimiteFim)
  //   if (control.value && control.value.length) {

  //     let dataInicio = control.value[0];
  //     let dataFim = control.value[1];

  //     if (!(dataInicio instanceof Date))
  //       dataInicio = dayjs(dataInicio, 'YYYY-MM-DD');
  //     else
  //       dataInicio = dayjs(dataInicio);

  //     if (!(dataFim instanceof Date))
  //       dataFim = dayjs(dataFim, 'YYYY-MM-DD');
  //     else
  //       dataFim = dayjs(dataFim);

  //     if (!dataInicio.isValid())
  //       return {
  //         dataRange: `Data inválida`,
  //       }

  //     if (!dataFim.isValid() || (dataInicio.toDate() > (dataFim.isValid() && dataFim.toDate())))
  //       return {
  //         dataRange: `Período inválido`
  //       }

  //     if (dataLimiteInicio && dataInicio && dataInicio.toDate() < dataLimiteInicio)
  //       return {
  //         dataRange: `A data não pode ser inferior a ${dayjs(dataLimiteInicio).format('DD/MM/YYYY')}`,
  //       }

  //     if (dataLimiteFim && dataFim && dataFim.toDate() > dataLimiteFim)
  //       return {
  //         dataRange: `A data não pode ser superior a ${dayjs(dataLimiteFim).format('DD/MM/YYYY')}`,
  //       }
  //   }
  //   return null;
  // }
}
